import { useEffect } from "react";
import { queries } from "../../../shared/queries";
import { useQuery } from "../../hooks/useQuery";
import { navigate, Route, routes, Switch, useRouteMatch } from "../../lib/urls";
import { Browse } from "./Browse";
import { Custom } from "./Custom";

export function Skills() {
  return (
    <Switch>
      <Route path={routes.skills.list}>
        <Custom />
      </Route>
      <Route path={routes.skills.browse}>
        <Browse />
      </Route>
      <Route path={routes.skills}>
        <RedirectBasedOnSkills />
      </Route>
    </Switch>
  );
}

function RedirectBasedOnSkills() {
  const [isList] = useRouteMatch(routes.skills.list);
  const [isBrowse] = useRouteMatch(routes.skills.browse);
  const [skills] = useQuery(queries.skillsIndex());

  useEffect(() => {
    if (!isList && !isBrowse) {
      if (skills.length === 0) {
        navigate(routes.skills.browse, undefined, { replace: true });
      } else {
        navigate(routes.skills.list, undefined, { replace: true });
      }
    }
  }, [isList, isBrowse, skills.length]);

  return null;
}
